import React from 'react'
import { navigate } from 'gatsby'
import hanger from '@images/no-results-found.svg'
import { ArrowRightIcon } from '@phosphor-icons/react'
import { MockProducts } from '@mockdata/mockdata'
import ProductSwiper from '@components/Home/Carousel/ProductSwiper'

const NoResultsFound = ({ showProductCards = false }) => {
	return (
		<React.Fragment>
			<div className="w-full">
				<section className="flex flex-col justify-center items-center gap-9 py-6">
					<img
						src={hanger}
						className="min-w-[244px] min-h-[66px]"
						alt="no results found"
					/>
					<div className="space-y-2 text-center">
						<h2 className="m-0">
							We couldn’t find any items matching your search
						</h2>
						<p>
							Try adjusting your filters or search terms, or browse all products
							to find what you’re looking for.
						</p>
					</div>
					{!showProductCards && (
						<button
							className="btn-primary flex flex-nowrap gap-x-2 items-center"
							onClick={() => {
								navigate("/collections/all");
							}}
						>
							Browse All Products
							<ArrowRightIcon size={20} weight="light" />
						</button>
					)}
				</section>
				{showProductCards && (
					<div>
						<p className='py-4'>Here's what you previously checked:</p>
						<div className="w-full flex p-2 justify-center gap-2">
							<ProductSwiper 
								products={MockProducts.slice(0, 5)} 
								cardStyles='h-[300px] md:h-[320px] lg:h-[340px]' 
								spaceBetween={5} 
								loop 
							/>
						</div>
					</div>
				)}
			</div>
		</React.Fragment>
	);
}

export default NoResultsFound